module.exports = __webpack_public_path__ + "static/media/bb-lost.09801f75.png";